var _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmoji({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#3C495D",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 9.5,
    r: 1.5,
    fill: "#3C495D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 9.5,
    r: 1.5,
    fill: "#3C495D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.475C7.5 14.475 9.03868 16.95 12.0387 16.95C15.0387 16.95 16.5 14.475 16.5 14.475",
    stroke: "#3C495D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.eb95ec6e30525c64e3218ff245a476e7.svg";
export { ForwardRef as ReactComponent };